import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { authAPI } from '../../services/api';
import CategoryPicker from '../common/CategoryPicker';
import { FOOD_CATEGORIES, AVOID_CATEGORIES, CLASSIFICATION_CATEGORIES, CATEGORY_ICONS } from '../../services/constants';
import './Onboarding.css';

export default function PreferencesPage() {
  const [categories, setCategories] = useState([]);
  const [avoids, setAvoids] = useState([]);
  const [classifications, setClassifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { updateUser } = useAuth();

  const toggle = (list, setList, item) => {
    setList(list.includes(item) ? list.filter(i => i !== item) : [...list, item]);
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      await authAPI.updatePreferences({ categories, avoids, classifications });
      await authAPI.completeOnboarding({ didOnboardingSelection: true });
      updateUser({ preferences: { categories, avoids, classifications }, didOnboardingSelection: true });
      navigate('/');
    } catch {
      navigate('/');
    }
    setLoading(false);
  };

  return (
    <div className="onboarding-page">
      <div className="preferences-card card">
        <div className="auth-header">
          <h1>What do you like?</h1>
          <p>Select your food preferences to get personalized recipes</p>
        </div>

        <CategoryPicker
          label="Food Categories"
          items={FOOD_CATEGORIES}
          selected={categories}
          onToggle={(item) => toggle(categories, setCategories, item)}
          icons={CATEGORY_ICONS}
        />

        <CategoryPicker
          label="Dietary Restrictions"
          items={AVOID_CATEGORIES}
          selected={avoids}
          onToggle={(item) => toggle(avoids, setAvoids, item)}
        />

        <CategoryPicker
          label="Dietary Lifestyle"
          items={CLASSIFICATION_CATEGORIES}
          selected={classifications}
          onToggle={(item) => toggle(classifications, setClassifications, item)}
        />

        <div className="onboarding-actions" style={{ marginTop: 24 }}>
          <button className="btn btn-secondary" onClick={() => navigate('/')}>Skip</button>
          <button className="btn btn-primary btn-lg" onClick={handleSave} disabled={loading}>
            {loading ? 'Saving...' : 'Save Preferences'}
          </button>
        </div>
      </div>
    </div>
  );
}
